<template>
  <b-card class="m-2 mr-3">
      <p>Create {{showSelectedType}} Extensible SMS</p>
    <div class="form-row mb-3">
      <b-col cols="12" sm="12">
        <input type="text" v-model="heading" class="form-control" id="heading" maxlength="100" placeholder="Click here to enter heading.">
        <div class="pull-right">
          <span class="small" :class="[isHeadingLimit ? 'text-danger' : 'muted']">{{ headingCharacters }}</span>
        </div>
      </b-col>
    </div>
    <div class="form-row mb-3">
        <b-col cols="12" sm="12">
          <quill-editor 
            :content="exmessage"
            :options="editorOption"
            @change="onEditorChange($event)"
          ></quill-editor>
        <div class="pull-right">
          <span class="small" :class="[isExmessageLimit ? 'text-danger' : 'muted']">{{ exMessageCharacters }}</span>
        </div>
        </b-col>
    </div>
    <div class="form-row mb-3">
      <b-col cols="12" sm="12" v-if="(showSelectedType==='image' || showSelectedType==='audio' || showSelectedType==='video')">
        <vue-dropzone ref="myVueDropzone" id="dropzone" @vdropzone-file-added="vfileAdded" v-on:vdropzone-sending="dzAppend" v-on:vdropzone-success="handleSuccessUpload" :options="dropzoneOptions"></vue-dropzone>
        <div class="pull-right">
          <span class="small" :class="[isFileConflict ? 'text-danger' : 'muted']">{{ fileNote }}</span>
        </div>
      </b-col>
    </div>
    <div class="mb-3">
        <div class="d-block">
          <b-form-checkbox v-model="isSubscribe" name="cbEnableSubscribe" value="true">Enable SMS Newsletter subscription</b-form-checkbox>
        </div>
        <div class="form-row mb-3 ml-3" block v-if="isSubscribe">
          <b-col cols="12" sm="12">
            <v-select id="selectedNewsletterSub" v-model="selectedNewsletter" :options="newsletters" placeholder="Select free SMS Newsletter"></v-select>
            <small class="text-danger">Note that you're the one to pay for the OTPs that will be sent to subscribers to verify their phone numbers. Do make sure your Zigatext account is well funded to avoid denying your audience access to your content.</small>
          </b-col>
        </div>
    </div>
    <div class="mb-3">
        <b-form-checkbox v-model="isFeedback" name="cbFeedback">Enable Feedback</b-form-checkbox>
    </div>
    <b-button class="mt-3" variant="primary" type="button" @click="handleSubmit" block>
    <span>{{actionText}}</span>
        <div class="sk-circle" v-if="uploading">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
        <i v-if="flashSendError" class="fa fa-times"></i>
    </b-button>
  </b-card>
</template>

<script>
import Vue from "vue"
import vSelect from 'vue-select'
import { mapGetters, mapActions, mapState } from "vuex"
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {extensibleTypes} from '@/constants'
import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// mount with global
Vue.use(VueQuillEditor)

export default {
  name: 'ComposeExensible',
  components: {
    vSelect,
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      modalTitle: 'Create Extensible SMS',
      extensibleTypes: extensibleTypes,
      actionText: 'Create',
      heading: '',
      exmessage: '',
      headingCharacters: '',
      exMessageCharacters: '',
      isFeedback: false,
      isSubscribe: false,
      selectedNewsletter: null,
      fileNote: '',
      isHeadingLimit: false,
      isExmessageLimit: false,
      isFileConflict: false,
      selectedMedia: 1,
      uploading: false,
      flashSendError: false,
      editorOption: {
        // Some Quill options...
        modules: {
          toolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote'],
                [{ 'header': '1' },{ 'header': '2' }],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                [{ 'size': ['small', false, 'large', 'huge'] }],
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['link'],
                [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                [{ 'font': [] }],
                [{ 'align': [] }],
                ['clean'],
            ]
        },
        placeholder: 'Click here to compose your message.',
      }
    }
  },
  notifications: {
    validationError: {
      title: 'Error',
      message: 'Kindly type in your message content and heading.',
      type: 'error'
    },
    fileValidateError: {
      title: 'Error',
      message: 'Kindly select a file.',
      type: 'error'
    },
    onlyImageAllowed: {
      title: 'Error',
      message: 'Only image files allowed.',
      type: 'error'
    },
    onlyAudioAllowed: {
      title: 'Error',
      message: 'Only audio files allowed.',
      type: 'error'
    },
    onlyVideoAllowed: {
      title: 'Error',
      message: 'Only video files allowed.',
      type: 'error'
    },
    fileTooLargeError: {
      title: 'Error',
      message: 'File limit exceeded. File should not be more than 10Mb.',
      type: 'error'
    },
    showFailedError: {
      title: 'Error',
      message: 'Error occurred while creating extensible.',
      type: 'error'
    },
    showSentSuccess: {
      title: 'Success',
      message: 'Extensible SMS created.',
      type: 'success'
    },
  },
  props: {
    showSelectedType: String,
    newsletters: {
      type: Array,
      required: false,
      default: () => []
    },
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('extensibleSms', ['loading']),
    
      dropzoneOptions() {
        let fileTypes = 'image/jpeg,.gif,.png'
        let fileSize = 0.10

        if (this.showSelectedType == this.extensibleTypes.audio) {
          fileTypes = 'audio/mpeg'
          fileSize = 5
        } else if (this.showSelectedType == this.extensibleTypes.video) {
           fileTypes = 'video/mp4'
           fileSize = 10
        }

        return {
            paramName: "file",
            url: `${process.env.VUE_APP_EXT_URL}/upload-${this.showSelectedType}`,
            maxFiles: 1,
            maxFilesize: fileSize,
            autoProcessQueue: false,
            dictDefaultMessage: `<i class='fa fa-cloud-upload'></i> Click or drag and drop your ${fileTypes} ${this.showSelectedType} file here`,
            headers: {
              "Cache-Control": null,
              "X-Requested-With": null,
            },
            acceptedFiles: fileTypes,
            addRemoveLinks: true,
        }
      },
      editor() {
        return this.$refs.myQuillEditor.quill
      }
  },
  mounted() {
    if (this.showSelectedType == this.extensibleTypes.image) {
      this.selectedMedia = 2;
    }
    if (this.showSelectedType == this.extensibleTypes.video) {
      this.selectedMedia = 3;
    }
    if (this.showSelectedType == this.extensibleTypes.audio) {
      this.selectedMedia = 4;
    }
  },
  methods: {
    ...mapActions('extensibleSms', [
        'mediaTypeFetchAll', 'createExtensibleSms'
    ]),
    dzAppend (file, xhr, formData) {
      formData.append('uuid', this.user.uuid);
    },
    handleSuccessUpload(file, serverResponse){
      if (serverResponse.code == 200 && serverResponse.fileUrl != ''){
        this.submitData(serverResponse.fileUrl)
      } else {
        this.actionText = 'Create'
        this.uploading = false
      }
    },
    vfileAdded(file) {
      if (this.showSelectedType == this.extensibleTypes.audio) {
        if (file.size > (10*1024*1024)) {
          this.$refs.myVueDropzone.removeAllFiles(true)
          this.isFileConflict = true
          this.fileTooLargeError()
        }
        
        if (file.type != 'audio/mpeg') {
          this.$refs.myVueDropzone.removeAllFiles(true)
          this.onlyAudioAllowed()
          this.isFileConflict = true
          this.fileNote = 'Kindly select an audio file with supported extension - .mp3'
        }
      } else if (this.showSelectedType == this.extensibleTypes.video) {
        if (file.size > (10*1024*1024)) {
          this.$refs.myVueDropzone.removeAllFiles(true)
          this.isFileConflict = true
          this.fileTooLargeError()
        }

        if (file.type != 'video/mp4') {
          this.$refs.myVueDropzone.removeAllFiles(true)
          this.onlyVideoAllowed()
          this.isFileConflict = true
          this.fileNote = 'Kindly select a video clip with supported extension - .mp4'
        } 
      } else if (this.showSelectedType == this.extensibleTypes.image) {
        if (file.size > (100*1024)) {
          this.$refs.myVueDropzone.removeAllFiles(true)
          this.isFileConflict = true
          this.fileTooLargeError({message:'File limit exceeded. File should not be more than 100kb.'})
        }
        if (file.type != 'image/jpg' && file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
          this.$refs.myVueDropzone.removeAllFiles(true)
          this.onlyImageAllowed()
          this.isFileConflict = true
          this.fileNote = 'Kindly select an image with one of the following extensions - .jpeg, .jpg, .png, .gif'
        }
      }
    },
    handleSubmit() {
      if (this.heading.length!='' && this.exmessage.length!='') {
        if (this.showSelectedType==='image' || this.showSelectedType==='audio' || this.showSelectedType==='video') {
          if (this.$refs.myVueDropzone.getQueuedFiles().length == 0){
            this.fileValidateError()
            return
          } 
        }

        if (this.isSubscribe && this.selectedNewsletter == null) {
          this.validationError({message: 'Kindly select SMS Newsletter list for subscription.'})
          return
        }
        this.actionText = ''
        this.uploading = true
        if (this.showSelectedType !== this.extensibleTypes.text) {
          this.$refs.myVueDropzone.processQueue()
        } else {
          this.submitData('')
        }
      } else {
          this.actionText = 'Create'
          this.uploading = false
          this.validationError()
        }
    },
    submitData: async function(mediaUrl){
        const requestData = {
          "uuid": this.user.uuid,
          "heading": this.heading,
          "content": this.exmessage,
          "media_type": this.selectedMedia,
          "media_url": mediaUrl,
          "subcode": (this.isSubscribe && this.selectedNewsletter != null) ? this.selectedNewsletter.value : '',
          "feedback": this.isFeedback
        }

        let status = await this.createExtensibleSms({data: requestData, type: this.showSelectedType})
        this.actionText = 'Create'
        if (status) {
          this.showSentSuccess()
          this.heading = ''
          this.exmessage = ''
          if (this.$refs.myVueDropzone instanceof Object) {
            this.$refs.myVueDropzone.removeAllFiles(true)            
          }
          this.selectedNewsletter = null
          this.isSubscribe = false
          this.isFeedback = false
          this.uploading = false
        } else {
          this.showFailedError()
        }
    },
    onEditorChange({ quill, html, text }) {
      let inputLen = 2000

      if (text.length > inputLen) {
        alert('Content too large.')

        let tempContent = this.exmessage
        quill.setContents([])
        quill.clipboard.dangerouslyPasteHTML(0, tempContent)
        
        return
      }

      this.exmessage = html
        
      this.exMessageCharacters = (text.length == 0) ? '' : `(Maximum Charaters: ${inputLen}), Characters left: ${(inputLen-text.length)}, Typed Characters: ${text.length}`
      this.isExmessageLimit = text.length >= inputLen
    }
  },
  watch: {
      heading(newValue, oldValue) {
        let inputLen = 100;
        this.headingCharacters = (this.heading.length == 0) ? '' : `(Maximum Charaters: ${inputLen}), Characters left: ${(inputLen-this.heading.length)}, Typed Characters: ${this.heading.length}`
        this.isHeadingLimit = this.heading.length >= inputLen
      },
      exmessage(newValue, oldValue) {
        let inputLen = 2000
        if (newValue > inputLen) {
          this.exmessage = oldValue
        }
        this.exMessageCharacters = (this.exmessage.length == 0) ? '' : `(Maximum Charaters: ${inputLen}), Characters left: ${(inputLen-this.exmessage.length)}, Typed Characters: ${this.exmessage.length}`
        this.isExmessageLimit = this.exmessage.length >= inputLen
      }
  },
}
</script>

<style type="text/css" scoped>
  .border-color {
      border: 1px #edebe9 solid;
  }
  .sk-circle{
    margin: 0 auto 1px auto;
    width: 20px;
    height: 20px;
    position: relative;
    color: white !important;
  }
</style>